module.exports = require('./helpers/bundle-url').getBundleURL('jsZAK') + "logo-dark.eefe0b7f.svg";